
import { Checkbox, Popconfirm, Popover, Select, Slider, Tooltip, Spin, Tabs, Button, message } from 'antd/es';
import { useEffect, useMemo, useRef, useState } from 'react';
import { DataIndexItem, OwnerDetails, UploadCompleteEvent } from '../../../types/interfaces';
import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { ReactComponent as EditIcon } from "../../../assets/svgs/icons/edit-icon.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/svgs/icons/delete-icon.svg";
import { ReactComponent as SettingIcon } from "../../../assets/svgs/icons/setting-icon.svg";
import { ReactComponent as ReloadIcon } from "../../../assets/svgs/icons/reload-icon.svg";
import { ReactComponent as ExpandIcon } from "../../../assets/svgs/icons/expand-icon.svg";
import { ReactComponent as CloseIcon } from "../../../assets/svgs/icons/close-icon.svg";
import { ReactComponent as ShrinkIcon } from "../../../assets/svgs/icons/shrink-icon.svg";
import { ReactComponent as ShareIcon } from "../../../assets/svgs/icons/share-icon.svg";
import { buildDataItem, deleteDataItem, loadDataIndex, loadDataItem, removeBatch } from '../../tables/dataIndexTable/DataIndexLambdaUtils';
import { DataIndexActionType } from '../../../common/constant';
import {
    changeDataItem,
    convertStatus,
    failedStatus,
    getDataItemWithDataId,
} from '../../tables/dataIndexTable/DataIndexUtils';
import {
    changeOpacity,
    setMaterialAttribute,
    existingPointCloudInViewer,
    loadPointCloud,
    removePointCloud,
    setPointSourcIdInPointCloud,
    translationPointCloud,
    zoomTo, changeIntensityScale,
    updateActiveProjection
} from '../../../common/potreeUtils';
import TranslationPanel from '../../tables/dataIndexTable/TranslationPanel';
import { ExclamationCircleOutlined, EyeInvisibleOutlined, EyeOutlined, InfoCircleOutlined, LoadingOutlined, ReloadOutlined } from '@ant-design/icons';
import BatchDetailsTable from './BatchDetailsTable';
import CreateBatch from './CreateBatch';
import { DataIndexMenuTableContainer } from '../DataManager.style';
import { emitCustomEvent, useCustomEventListener } from 'react-custom-events';
import DataIndexMenuEditModal from '../../conversionMenu/dataIndexEditModal/DataIndexMenuEditModal';
import { generateDataItem } from '../../upload/uploadUtiles';
import { addDataItemStore, DataStore, getDataItemFromDataId, getOwnerS3Store, removeDataItemStore, updateItemStore } from '../../../store/DataStore';
import { useSnapshot } from 'valtio';
import { changeDataItemStore } from '../../../store/DataStore';
import ShareDataModal from '../../tables/user/share/ShareDataModal';
const DefaultValue = 0; // TODO: Need to remove

const { Option } = Select;

interface DataIndexMenuTableProps {
    visible: boolean;
    setActiveMenu: (menuName: string | null) => void;
}
enum DataTypeTab {
    DATA = "Data",
    BATCH = "Batch",
    BATCH_DETAILS = "Batch Details",
    LOADED_DATA = "Loaded Data"
}

const DataIndexMenuTable = ({ visible, setActiveMenu }: DataIndexMenuTableProps) => {
    const [dataLoading, setDataLoading] = useState<boolean>(false);
    const [expand, setExpand] = useState<boolean>(false);
    const [owner, setOwner] = useState<string | undefined>(undefined);
    const [owners, setOwners] = useState<string[]>([]);
    const [ownersDetails, setOwnersDetails] = useState<OwnerDetails[]>([]);
    // const [tableData, setTableData] = useState<DataIndexItem[]>([]);
    const [lastEvaluatedKey, setLastEvaluatedKey] = useState<string | null>(null);
    const [selectedDataIndexRow, setSelectedDataIndexRow] = useState<DataIndexItem | undefined>(undefined);
    const [showDataIndexEditModal, setShowDataIndexEditModal] = useState(false);
    const [showDataIndexShareModal, setShowDataIndexShareModal] = useState(false);
    const [selectedId, setSelectedId] = useState<string>("");
    const [selectedDataItems, setSelectedDataItems] = useState<DataIndexItem[]>([]);
    const [batchModelVisible, setBatchModelVisible] = useState<boolean>(false);
    const [activeTabKey, setActiveTabKey] = useState<string>("1"); // TODO: Need to remove
    const [filteredData, setFilteredData] = useState<DataIndexItem[]>([]);
    const [loadedDataIds, setLoadedDataIds] = useState<string[]>([]);
    const [isOnlyLoaded, setIsOnlyLoaded] = useState<boolean>(false);
    const snap = useSnapshot(DataStore);

    const columnsData = [
        { title: "", key: "show", size: 35 },
        { title: "Name", key: "name", size: 250, },
        { title: "EPSG", key: "raw_epsg", size: 100 },
        { title: "Epoch", key: "raw_epoch", size: 90 },
        { title: "Geoid", key: "raw_geoid", size: 90 },
        { title: "Acq", key: "acquisition_date", size: 150 },
        { title: "Type", key: "acquisition_type", size: 170 },
        { title: "Process Status", key: "conversion_status", size: 110 },
        { title: "Size (GB)", key: "raw_size", size: 80 },
        { title: "Action", key: "operation", size: 180, }
    ];

    if (activeTabKey === "2") {
        columnsData.shift(); // Remove the checkbox in a batch column data
    }

    const tableRef = useRef(null);

    useEffect(() => {
        emitCustomEvent("DataIndexTableChanged", { tableData: DataStore.dataItems });
    }, [snap.dataItems]);

    const openBatchModal = (id:string) => {
        setSelectedId(id)
        setActiveTabKey("3")
    }

    useEffect(() => {
        async function init() {
            const allData = DataStore.dataItems;
            const data = []
            if (activeTabKey === "4") {
                data.push(...allData.filter((item) => loadedDataIds.includes(item.data_id)))
                setFilteredData(data)
                return;
            }
            if (!owner) return;
            let ownerData = allData.filter((item) => item.owner_id === owner);
            // Check owner data is fetched or not
            const ownerDataFetched = ownerData.length > 0;
            if(!ownerDataFetched) {
                setDataLoading(true);
                try {
                    const { _tableData, _lastEvaluatedKey } = await loadDataIndex(lastEvaluatedKey, owner);
                    ownerData.push(..._tableData)
                    setLastEvaluatedKey(_lastEvaluatedKey);
                } catch (e: any) {
                    console.error(e);
                    if(typeof e === 'string') {
                        message.error(e);
                        return;
                    }
                    message.error(e?.message || e?.errMessage || 'Failed to load data');
                } finally {
                    setDataLoading(false);
                }
            }
            if (activeTabKey === "1") {
                data.push(...ownerData.filter((item) => !item.batch && !Boolean(item.batch_parent)))
            } else if (activeTabKey === "2") {
                data.push(...ownerData.filter((item) => item.batch))
            }
            setFilteredData(data)
        }
        init()
    },[owner, activeTabKey, snap.dataItems])

    useEffect(() => {
        setSelectedDataItems([]); // TODO: Need to check we need this or can move in upper useEffect
    }, [activeTabKey, owner])

    const columns = useMemo<MRT_ColumnDef<any>[]>(() => {
        if (filteredData.length === 0) {
            return [];
        }
        return columnsData.map(({ title, key, size }) => {
            if (key === "name") {
                return {
                    accessorKey: key,
                    enableSorting: false,
                    header: title || "",
                    size: size,
                    Cell: ({ row }) => {
                        const record: DataIndexItem = row.original;
                        let disabled = record.entwine_build_path === "";
                        if(!disabled) {
                            let isConversion = convertStatus.includes(record.conversion_status);
                            let isFailed = failedStatus.includes(record.conversion_status);
                            disabled = isConversion || isFailed;
                        }
                        return (
                            <div className='name_btn'>
                                <button
                                    className={`button-name${disabled ? "-disabled" : ""}`}
                                    type="button"
                                    disabled={disabled}
                                    onClick={() => onActionHandler(DataIndexActionType.ZoomTo, record.data_id, DefaultValue)}
                                >
                                    {record.name || record.data_id}
                                </button>
                                {
                                    failedStatus.includes(record.conversion_status) && (
                                        <ExclamationCircleOutlined />
                                    )
                                }
                                {
                                    convertStatus.includes(record.conversion_status) && (
                                        <LoadingOutlined />
                                    )
                                }
                                {record.batch && (
                                    <InfoCircleOutlined className='infoIcon' onClick={() => openBatchModal(record.data_id)} />
                                )}
                                
                            </div>
                        );
                    },
                };
            } else if (key === "show") {
                return {
                    accessorKey: key,
                    enableSorting: false,
                    header: title || "",
                    size: size,
                    Cell: ({ row }) => {
                        const record: DataIndexItem = row.original;
                        const showConfirm = (e : any) => {
                            setSelectedDataItems((prev) => {
                                const isChecked = e.target.checked;
                                if(!isChecked) {
                                    return prev.filter((item) => item.data_id !== record.data_id);
                                } else {
                                    if(prev.find((item) => item.data_id === record.data_id)) {
                                        return prev;
                                    }else{
                                        return [...prev, record];
                                    }
                                }
                            });
                        };
                        const isSelected = selectedDataItems.find((item) => item.data_id === record.data_id);

                        return (
                            <div style={{ width: size }} className="table_checkbox_section">
                                {(
                                    <Checkbox onChange={showConfirm} checked={Boolean(isSelected)} />
                                )}
                            </div>
                        );
                        // return (
                        //     <div style={{ width: size }} className='table_checkbox_section'>
                        //         <Checkbox checked={false}/>
                        //     </div>
                        // );
                    }
                }
            } else if (key === "operation") {
                return {
                    accessorKey: key,
                    enableSorting: false,
                    header: title || "",
                    size: size,
                    Cell: ({ row }) => {
                        const [isDeleting, setIsDeleting] = useState(false);
                        const record: DataIndexItem = row.original;
                        const showConfirm = () => {
                            const annotations = window.potreeViewer.scene.annotations.flatten();
                            const annotation = annotations.find((at: any) => at.title === record.name);
                            if (annotation) {
                                annotation.visible = !record.show;
                            }
                            onActionHandler(
                                record.show ? DataIndexActionType.Hide : DataIndexActionType.Show,
                                record.data_id,
                                DefaultValue
                            );
                        };
                        const editConfirm = () => onActionHandler(DataIndexActionType.Edit, record.data_id, DefaultValue);
                        const reloadConfirm = () => onActionHandler(DataIndexActionType.Reload, record.data_id, DefaultValue);
                        const deleteConfirm = () => {
                            setIsDeleting(true);
                            onActionHandler(DataIndexActionType.Delete, record.data_id, DefaultValue, () => {
                                setIsDeleting(false);
                            });
                        }
                        // const opacityChanged = (value: number) =>
                        //     actionHandler(DataIndexActionType.Opacity, record.data_id, value);
                        const attributeChanged = (value: string) =>
                            onActionHandler(DataIndexActionType.Attribute, record.data_id, value);
                        const intensityChanged = (value: number) =>
                            onActionHandler(DataIndexActionType.Intensity, record.data_id, value);

                        if(isDeleting) {
                            return (
                                <div className="actionIconBox">
                                    <Spin />
                                    <span>Deleting...</span>
                                </div>
                            );
                        }

                        return (
                            <div className="actionIconBox">
                                {record.entwine_build_path !== "" && (
                                    <>
                                        {record.show ? (
                                            <Tooltip title="Hide">
                                                <EyeInvisibleOutlined onClick={showConfirm}/>
                                            </Tooltip>
                                        ):(
                                            <Tooltip title="Show">
                                                <EyeOutlined onClick={showConfirm}/>
                                            </Tooltip> 
                                        )}
                                    </>
                                )}
                                <Tooltip title="Edit">
                                    <EditIcon key="EditIcon" title="Edit" color='#ffffff' onClick={editConfirm} />
                                </Tooltip>
                                <Tooltip title="Delete">
                                    <Popconfirm
                                        placement="topRight"
                                        title="Are you sure to delete this item?"
                                        onConfirm={deleteConfirm}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <DeleteIcon key="DeleteIcon" title="Delete" color='#ffffff' />
                                    </Popconfirm>
                                </Tooltip>
                               
                                {record.entwine_build_path !== "" && (
                                    <>
                                        <TranslationPanel record={record} actionHandler={onActionHandler} />
                                     
                                        <Popover
                                            placement="bottomRight"
                                            content={
                                                <div style={{ width: 200 }}>
                                                    <h4>Attribute</h4>
                                                    <Select defaultValue={record.default_material} onChange={attributeChanged}>
                                                        <option value="rgba">RGB</option>
                                                        <option value="intensity">Intensity</option>
                                                        <option value="classification">Classification</option>
                                                    </Select>
                                                    <h4>Intensity Scale</h4>
                                                    <Slider
                                                        min={record.intensity_min}
                                                        max={record.intensity_max}
                                                        step={1}
                                                        marks={{
                                                            0: record.intensity_min,
                                                            1: record.intensity_max
                                                        }}
                                                        defaultValue={record.intensity_max}
                                                        onChange={intensityChanged}
                                                    />
                                                </div>
                                            }
                                            trigger="click"
                                        >
                                            <Tooltip title="Edit">
                                            <SettingIcon key="SettingIcon" title="Setting" color='#ffffff' style={{ pointerEvents: !record.loaded ? "none" : "auto" }} />
                                            </Tooltip>
                                        </Popover>
                                    </>
                                )}
                             
                                {record.entwine_build_path !== "" && (
                                      <Tooltip title="Reload">
                                    <ReloadIcon key="ReloadIcon" title="Reload" color='#ffffff' onClick={reloadConfirm} />
                                </Tooltip>
                                )}
                              
                            </div>
                        );
                    }
                }
            } else {
                let data = {
                    accessorKey: key,
                    header: title || "",
                    size: size,
                }
                return data
            };

        })
    }, [filteredData, selectedDataItems]);

    const table = useMaterialReactTable({
        autoResetPageIndex: false,
        columns,
        data: filteredData,
        enableSorting: false,
        positionToolbarAlertBanner: 'none',
        rowNumberDisplayMode: "static",
        initialState: {
            showGlobalFilter: true,
            pagination: { 
                pageSize: 10, 
                pageIndex: 0 
            },
        },
       // Define page size options
        renderTopToolbarCustomActions: ({ table }) => (
            <>
                {!isOnlyLoaded &&
                    (
                        <Select onChange={handleOwnerChange} value={owner} className="custom-select-dropdown">
                            {owners.map(id => {
                                const owner = ownersDetails.find((item) => item.owner_id === id);
                                const name = owner?.owner_name ? owner.owner_name : id;

                                return (
                                    <Option key={id} value={id}>{name}</Option>
                                )
                            })}
                        </Select>
                    )
                }
            </>
        ),
        renderBottomToolbarCustomActions: ({ table }) => (
            <>
                {activeTabKey !== '4' && (
                    <div className='create_batch_block'>
                        <Button className='batch_btn' disabled={selectedDataItems.length > 0 ? false : true} onClick={handleAddBatch}>
                            Add to Batch
                        </Button>
                        <Button className='batch_btn share_data_btn' disabled={selectedDataItems.length > 0 ? false : true} onClick={handleShare}>
                    Share
                </Button>
            </div>
                )}
            </>
        ),
    });

    if (!table) {
        return null;
    }

    const tabItems = [
        {
            label: (
                <span>
                    Data
                </span>
            ),
            key: '1',
            children: (
                <div className="inputData_table_searchable dataIndex_table">
                    <div className='loading_box'>
                        <Spin spinning={dataLoading}>
                            <div ref={tableRef} className={`materialReactTableCustom material_menu_table ${expand ? 'expand' : ''}`}>
                                <MaterialReactTable table={table} />
                            </div>
                        </Spin>
                    </div>
                </div>
            ),
        },
        {
            label: (
                <span>
                    Batch
                </span>
            ),
            key: '2',
            children: (
                <div className="inputData_table_searchable dataIndex_table">
                    <div className='loading_box'>
                        <Spin spinning={dataLoading}>
                            <div ref={tableRef} className={`materialReactTableCustom material_menu_table ${expand ? 'expand' : ''}`}>
                                <MaterialReactTable table={table} />
                            </div>
                        </Spin>
                    </div>
                </div>
            ),
        },
    ];
    if(activeTabKey === "3") {
        tabItems.push({
            label: (
                <span>
                    Batch Details
                </span>
            ),
            key: '3',
            children: (
                <div className="inputData_table_searchable dataIndex_table">
                    <div className='loading_box'>
                        <Spin spinning={dataLoading}>
                            <BatchDetailsTable selectedId={selectedId} expand={expand} />
                        </Spin>
                    </div>
                </div>
            )
        })
    }

    tabItems.push({
        label: (
            <span>
                Loaded Data
            </span>
        ),
        key: '4',
        children: (
            <div className="inputData_table_searchable dataIndex_table">
                <div className='loading_box'>
                    <Spin spinning={dataLoading}>
                        <div ref={tableRef} className={`materialReactTableCustom material_menu_table ${expand ? 'expand' : ''}`}>
                            <MaterialReactTable table={table} />
                        </div>
                    </Spin>
                </div>
            </div>
        )
    })

    const handleAddBatch = () => {
        if (selectedDataItems.length === 0) {
            message.warning('Please select at least one item to add to batch');
            return;
        }
        setBatchModelVisible(true);
    };

    const handleShare = () => {
        if (selectedDataItems.length === 0) {
            message.warning('Please select at least one item to share');
            return;
        }
        setShowDataIndexShareModal(true)
    };
    

    useEffect(() => {
        async function init() {
            setDataLoading(true);
            try {
                const { _ownerIds, _lastEvaluatedKey, _ownerDetails } = await loadDataIndex(lastEvaluatedKey, owner);
                setOwners(_ownerIds);
                setOwner(_ownerIds[0]);
                const arr: OwnerDetails[] = []
                _ownerIds.forEach((item: string) => {
                    arr.push({
                        owner_id: item,
                        owner_name: _ownerDetails[item]?.name
                    })
                })
                setOwnersDetails(arr)
                setLastEvaluatedKey(_lastEvaluatedKey);
                setDataLoading(false)
            }catch(e) {
                setDataLoading(false);
            }
        }
        init();
        return () => {
            console.log('clean')
        }
    }, []);

    useCustomEventListener("unlocked", (event: any) => {
        const { data_id, owner_id } = event;
        setDataLoading(true);
        loadDataItem(data_id, owner_id).then(async (res) => {
            const dataItem = getDataItemFromDataId(data_id);
            if (!dataItem) return;
            const pointCloud = existingPointCloudInViewer(dataItem);
            if(pointCloud) {
                removePointCloud(pointCloud, dataItem);
            }
            updateItemStore(data_id, { ...res });
        }).catch((error) => {
            console.log(error);
            message.error('Failed to reload data');
        }).finally(() => {
            setDataLoading(false);
            setSelectedDataIndexRow(undefined);
            setShowDataIndexEditModal(false);
        });
    })

    useCustomEventListener("UploadComplete", (event: UploadCompleteEvent ) => {
        const { success, fileData } = event;
        if(!success) return;

        generateDataItem(fileData.hash, fileData.ownerId, fileData.file, (body: any) => {

            loadDataItem(fileData.hash, fileData.ownerId).then((res) => {
                const item = buildDataItem(res);
                addDataItemStore(item);
                message.success('Data added in data index successfully');
            }).catch((error) => {
                message.error('Failed to add data in data index');
                console.log(error);
            })
        });
    });

    const updateDataTables = (dataId: string) => {
        const tempTableData = DataStore.dataItems
    }

    function handleOwnerChange(value: any) {
        setOwner(value);
    }

    function closeCardBox(value: any) {
        setActiveMenu(null)
    }

    function expandTable(value: any) {
        setExpand(!expand)
    }

    const onActionHandler = async (actionType: DataIndexActionType, dataId: string, value: any, callback? :() => void) => {
        const dataItem = getDataItemWithDataId(DataStore.dataItems, dataId);
        if (!dataItem) return;

        const pointCloud = existingPointCloudInViewer(dataItem);

        if (actionType === DataIndexActionType.Opacity && typeof value === "number") {
            changeOpacity(dataItem, value);
        } else if (actionType === DataIndexActionType.Attribute && typeof value === "string") {
            setMaterialAttribute(dataItem, value);
        } else if (actionType === DataIndexActionType.Intensity && typeof value === "number") {
            changeIntensityScale(dataItem, value);
        } else if (actionType === DataIndexActionType.Delete) {
            // setDataLoading(true);
            if(dataItem.batch) {
                removeBatch(dataItem.data_id, dataItem.owner_id).then(() => {
                    message.success('Batch deleted successfully');
                    removeDataItemStore(dataItem.data_id);
                    setDataLoading(false);
                }).catch((error) => {
                    setDataLoading(false);
                    message.error('Failed to delete batch');
                }).finally(() => {
                    callback && callback();
                })
            } else {
                deleteDataItem(dataItem.data_id, dataItem.owner_id).then(() => {
                    removePointCloud(pointCloud, dataItem);
                    message.success('Data deleted successfully');
                    removeDataItemStore(dataItem.data_id);
                }).catch((error) => {
                    console.log(error);
                    message.error('Failed to delete data');
                }).finally(() => {
                    callback && callback();
                })
            }

        } else if (actionType === DataIndexActionType.Reload) {
            setDataLoading(true);
            loadDataItem(dataItem.data_id, dataItem.owner_id).then(async (res) => {
                removePointCloud(pointCloud, dataItem);
                const uuid = await loadPointCloud(dataItem, false);
                updateItemStore(dataId, {
                    ...res,
                    uuid: uuid,
                });
                message.success('Data reloaded successfully');
            }).catch((error) => {
                console.log(error);
                message.error('Failed to reload data');
            }).finally(() => {
                setDataLoading(false);
            });
        } else {
            if (actionType === DataIndexActionType.Translation) {
                const translationV3 = dataItem.translationV3;

                if (value.axis === "X") translationV3.x = value.value;
                else if (value.axis === "Y") translationV3.y = value.value;
                else translationV3.z = value.value;
                updateItemStore(dataId, { translationV3: translationV3 });
                translationPointCloud({ ...dataItem, translationV3: translationV3 });
                return;
            }

            let uuid = "";
            if (pointCloud) {
                uuid = pointCloud.uuid;
            }

            if (actionType === DataIndexActionType.Edit) {
                setSelectedDataIndexRow(dataItem);
                setShowDataIndexEditModal(true);
            } 
            // else if (actionType === DataIndexActionType.Share) {
            //     setSelectedDataIndexRow(dataItem);
            //     setShowDataIndexShareModal(true);
            // } 
            else if (actionType === DataIndexActionType.Show || actionType === DataIndexActionType.Hide) {
                const showValue = actionType === DataIndexActionType.Show;
                if (showValue) {
                    if (pointCloud) {
                        translationPointCloud(dataItem);
                        setPointSourcIdInPointCloud(pointCloud, parseInt(dataItem.id_iterator, 10), false);

                        pointCloud.visible = true;
                        updateActiveProjection(dataItem)
                    } else {
                        try {
                            uuid = await loadPointCloud(dataItem, false);
                        } catch (e) {
                            message.error('Failed to load point cloud');
                            return
                        }
                    }
                    changeDataItemStore(dataItem.data_id, { show: true });
                } else {
                    if (pointCloud.point_source_id) {
                        translationPointCloud(dataItem);
                        setPointSourcIdInPointCloud(pointCloud, parseInt(dataItem.id_iterator, 10), true);
                    } else {
                        pointCloud.visible = false;
                    }

                    uuid = pointCloud.uuid;
                    changeDataItemStore(dataItem.data_id, { show: false });
                }
                updateItemStore(dataId, { show: showValue, uuid: uuid, loaded : true });
            } else if (actionType === DataIndexActionType.ZoomTo) {
                if (pointCloud) {
                    zoomTo(dataItem);
                } else {
                    try {
                        uuid = await loadPointCloud(dataItem, true);
                    } catch (e) {
                        message.error('Failed to load point cloud');
                        return
                    }
                }
                updateItemStore(dataId, { show: true, uuid: uuid, loaded : true });
            }
            if (actionType === DataIndexActionType.Show || actionType === DataIndexActionType.ZoomTo) {
                // Add dataId to loadedDataIds to filter out the dataIds that are already loaded and show in the data index table
                const newSet = new Set(loadedDataIds);
                newSet.add(dataId);
                if (!dataItem.loaded) {
                    updateItemStore(dataId, { loaded: true });
                }
                setLoadedDataIds(Array.from(newSet));
            }
        }
    };
    const onReload = async () => {
        if (activeTabKey === '4') {
            setLoadedDataIds(loadedDataIds.filter((item) => {
                const dataItem = getDataItemFromDataId(item)
                return dataItem && dataItem.show;
            }))
        } else {
            setDataLoading(true);
            try {
                const { _tableData, _lastEvaluatedKey } = await loadDataIndex(lastEvaluatedKey, owner);
                setLastEvaluatedKey(_lastEvaluatedKey);
                setDataLoading(false)
            }catch(e) {
                setDataLoading(false);
                console.error(e);
            }
        }
    }

    const handleTabChange = (key: string) => {
        setActiveTabKey(key)
    };
    return (
        <>
            {
                visible &&
                <DataIndexMenuTableContainer>
                        <div className='table-container'>
                            <div className="custom-tab-container">
                                {(
                                    <Tabs activeKey={activeTabKey} onChange={handleTabChange} className="custom-tabs">
                                        {tabItems.map(item => (
                                            <Tabs.TabPane key={item.key} tab={item.label}>
                                                {item.children}
                                            </Tabs.TabPane>
                                        ))}
                                    </Tabs>
                                )}
                                <div className="tab-icons">
                                    <>
                                        {(activeTabKey !== "3") && (
                                            <ReloadOutlined key="reload" title="Reload" onClick={() => onReload()} style={{ color: "#ffffff" }} />
                                        )}
                                        {expand ?
                                            <ShrinkIcon key="ShrinkIcon" title="Shrink" color='#ffffff' onClick={expandTable} style={{ marginLeft: 8 }} />
                                            :
                                            <ExpandIcon key="ExpandIcon" title="Expand" color='#ffffff' onClick={expandTable} style={{ marginLeft: 8 }} />
                                        }
                                        <CloseIcon key="CloseIcon" title="Close" color='#ffffff' style={{ marginLeft: 8 }} onClick={closeCardBox} />
                                    </>
                                </div>
                            </div>
                        </div>

                        {showDataIndexEditModal && selectedDataIndexRow && (
                            <DataIndexMenuEditModal data={selectedDataIndexRow}
                                onCancel={() => {
                                    setSelectedDataIndexRow(undefined);
                                    setShowDataIndexEditModal(false);
                                }}
                                onChanged={updateDataTables} />
                        )}   
                        {showDataIndexShareModal && (
                            <ShareDataModal setShow={setShowDataIndexShareModal} selectedItems={selectedDataItems}/>
                        )}                      
                        {batchModelVisible && selectedDataItems.length && (
                            <CreateBatch
                                onCancel={(inBatchId) => {
                                    setBatchModelVisible(false)
                                    if(!inBatchId) return;
                                    if(!owner) return;
                                    loadDataItem(inBatchId, owner).then((res) => {
                                        setSelectedDataItems([]);
                                        let status = updateItemStore(inBatchId, { ...res, batch: true, source_ids: res.source_ids });
                                        if (!status) {
                                            const item = buildDataItem(res);
                                            addDataItemStore(item);
                                        }
                                        res.source_ids.forEach((id: string) => {
                                            updateItemStore(id, { batch_parent: inBatchId });
                                        });
                                    }).catch((error) => {
                                        console.log(error);
                                    });
                                }}
                                selectedBatchItems={selectedDataItems}
                                tableData={DataStore.dataItems}
                            />
                        )}
                </DataIndexMenuTableContainer>
            }
        </>
    );
}

export default DataIndexMenuTable;

